import React from 'react';
import styles from './HotkeyDetails.module.scss';
import { Hotkey } from 'store';

const formatKeyCombination = keyCombination => {
  const result = keyCombination.split('+').join(' + ');
  return result;
};

const HotkeyDetails = ({ keyCombination, description }: Hotkey) => {
  return (
    <div className={styles.container}>
      <div><span>{formatKeyCombination(keyCombination)}</span></div>
      <div><span>{description}</span></div>
    </div>
  );
};

export default HotkeyDetails;
